import React from 'react';

/**
 * Summaros brand mark and lockup.
 *
 * Uses the authored PNG assets in /public:
 *   - summaros-mark.png    (symbol only — figure inside a circle)
 *   - summaros-lockup.png  (full vertical lockup with wordmark)
 *
 * `SummarosMark` is a drop-in <img> that renders the symbol at any
 * pixel size. `Logo` is the header/footer lockup: mark on the left,
 * "Summaros" wordmark on the right, tinted warm-brown to match the
 * authored file. For splash-style placements (login/welcome/auth
 * callback) prefer `SummarosLockup` — the full authored image.
 */
export const SummarosMark = ({ size = 28, className = '' }) => (
  <img
    src="/summaros-mark.png"
    alt=""
    width={size}
    height={size}
    className={`select-none pointer-events-none ${className}`}
    draggable={false}
    aria-hidden="true"
  />
);

export const SummarosLockup = ({ width = 220, className = '', testid = 'brand-lockup' }) => (
  <img
    src="/summaros-lockup.png"
    alt="Summaros"
    width={width}
    className={`h-auto select-none ${className}`}
    draggable={false}
    data-testid={testid}
  />
);

const SIZE = {
  default:  { mark: 28, text: 'text-[20px]' },
  compact:  { mark: 24, text: 'text-[17px]' },
  mark:     { mark: 30, text: null },
  wordmark: { mark: null, text: 'text-[20px]' },
};

const Logo = ({ variant = 'default', className = '', testid = 'brand-logo', tone = 'dark' }) => {
  const s = SIZE[variant] || SIZE.default;
  // Warm-brown wordmark to match the authored logo palette.
  const textColor = tone === 'light' ? 'text-cream' : 'text-[#8B5E3C]';

  return (
    <span
      className={`inline-flex items-center gap-2 select-none ${className}`}
      data-testid={testid}
      aria-label="Summaros"
    >
      {s.mark && <SummarosMark size={s.mark} />}
      {s.text && (
        <span
          className={`font-body font-medium tracking-tight ${s.text} ${textColor}`}
          style={{ letterSpacing: '-0.005em' }}
        >
          Summaros
        </span>
      )}
    </span>
  );
};

export default Logo;
